var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRideTrips(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 28C6 26.3431 7.34315 25 9 25C10.6569 25 12 26.3431 12 28C12 29.6569 10.6569 31 9 31C7.34315 31 6 29.6569 6 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 8C30 6.34315 31.3431 5 33 5C34.6569 5 36 6.34315 36 8C36 9.65685 34.6569 11 33 11C31.3431 11 30 9.65685 30 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 27C14.5 24 17 21 21 21C25 21 27.5 16 31 10",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 15.5L24.8 11.2C24.4 10.2 23.4 9.5 22.3 9.5H13.7C12.6 9.5 11.6 10.2 11.2 11.2L9.5 15.5C8.6 15.8 8 16.7 8 17.7V23.5C8 24.3 8.7 25 9.5 25H10.5C11.3 25 12 24.3 12 23.5V22.5H24V23.5C24 24.3 24.7 25 25.5 25H26.5C27.3 25 28 24.3 28 23.5V17.7C28 16.7 27.4 15.8 26.5 15.5ZM12.8 12.2C13 11.8 13.3 11.5 13.8 11.5H22.2C22.7 11.5 23 11.8 23.2 12.2L24.5 15.5H11.5L12.8 12.2ZM11.5 19.5C10.7 19.5 10 18.8 10 18C10 17.2 10.7 16.5 11.5 16.5C12.3 16.5 13 17.2 13 18C13 18.8 12.3 19.5 11.5 19.5ZM24.5 19.5C23.7 19.5 23 18.8 23 18C23 17.2 23.7 16.5 24.5 16.5C25.3 16.5 26 17.2 26 18C26 18.8 25.3 19.5 24.5 19.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRideTrips);
export default __webpack_public_path__ + "static/media/ic_ride_trips.144ef75caaaaacc77030573054d9e3bd.svg";
export { ForwardRef as ReactComponent };